import {
  EDIT_CUSTOMER,
  EDIT_CUSTOMER_SUCCESS,
  EDIT_CUSTOMER_CLEAN,
  EDIT_CUSTOMER_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  customer: {},
}

const CustomerEdit = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_CUSTOMER:
      state = {
        ...state,
        loading: true,
      }
      break
    case EDIT_CUSTOMER_SUCCESS:
      state = {
        ...state,
        customer: action.payload.customer,
        loading: false,
        done: true,
      }
      break
    case EDIT_CUSTOMER_CLEAN:
      state = initialState
      break
    case EDIT_CUSTOMER_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default CustomerEdit
